import { cn } from "@/lib/utils";
import React, { ReactNode } from "react";

interface AuroraBackgroundProps extends React.HTMLProps<HTMLDivElement> {
  children: ReactNode;
  showRadialGradient?: boolean;
}

export const AuroraBackground = ({
  className,
  children,
  showRadialGradient = true,
  ...props
}: AuroraBackgroundProps) => {
  return (
    <div
      className={cn(
        "relative flex flex-col min-h-[100vh] h-auto items-center justify-center bg-white dark:bg-fs-dark-950 text-foreground transition-bg",
        className
      )}
      {...props}
    >
      <div className="absolute inset-0 overflow-hidden">
        <div
          className={cn(
            `
            [--white-gradient:repeating-linear-gradient(100deg,var(--zinc-50)_0%,var(--zinc-50)_7%,var(--transparent)_10%,var(--transparent)_12%,var(--zinc-50)_16%)]
            [--dark-gradient:repeating-linear-gradient(100deg,var(--zinc-900)_0%,var(--zinc-900)_7%,var(--transparent)_10%,var(--transparent)_12%,var(--zinc-900)_16%)]
            [--aurora:repeating-linear-gradient(100deg,var(--fs-purple-500)_10%,var(--fs-cyan-400)_15%,var(--fs-magenta-300)_20%,var(--fs-purple-300)_25%,var(--fs-cyan-500)_30%)]
            [background-image:var(--white-gradient),var(--aurora)]
            dark:[background-image:var(--dark-gradient),var(--aurora)]
            [background-size:300%,_200%]
            [background-position:50%_50%,50%_50%]
            filter blur-[10px]
            after:content-[""] after:absolute after:inset-0 after:[background-image:var(--white-gradient),var(--aurora)]
            after:dark:[background-image:var(--dark-gradient),var(--aurora)]
            after:[background-size:200%,_100%]
            after:animate-aurora after:[background-attachment:fixed] after:mix-blend-difference
            pointer-events-none
            absolute -inset-[10px] opacity-50 will-change-transform
            motion-reduce:after:animate-none`,

            showRadialGradient &&
              `[mask-image:radial-gradient(ellipse_at_100%_0%,black_10%,var(--transparent)_70%)]`
          )}
        ></div>
      </div>
      {children}
    </div>
  );
};
